/**
 * Array of HTTP status codes to ignore in Sentry
 * You can add more status codes to ignore here
 */
export const ignoredStatusCodes = [401, 404, 403];

/**
 * Determines if an error should be reported to Sentry based on its status code
 * @param {Error} error - The error object
 * @returns {boolean} - Returns true if the error should be reported, false otherwise
 */
export const shouldReportErrorToSentry = (error) => {
  if (!error?.response) {
    return true;
  }

  const statusCode = error.response.status;
  return !ignoredStatusCodes.includes(statusCode);
};
